import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const name = 'breadcrumbs';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

export const breadcrumbsActions = { ...slice.actions, ...extraActions };
export const breadcrumbsReducer = slice.reducer;

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        //value: JSON.parse(localStorage.getItem('auth'))
        url_list: [],
        current_title: null,
        selected_menu_index: 0,
        current_page_index: 0,
        highest_page_index: 0,
        total_reloads: 0,
        reverse_navigation_mode: false,
        previous_url: {
            url: "/home",
            state: {}
        }
    }
}

function createExtraActions() {

    return {
        setCurrentURL: setCurrentURL(),
        setCurrentTitle: setCurrentTitle(),
        setSelectedMenuIndex: setSelectedMenuIndex(),
        setCurrentPageIndex: setCurrentPageIndex(),
        getPreviousURL: getPreviousURL()
    };

    function setCurrentURL() {
        return createAsyncThunk(
            `${name}/setCurrentURL`,
            async function ({url, state}) {
                return {url, state};
            }
        );
    }

    function setCurrentTitle() {
        return createAsyncThunk(
            `${name}/setCurrentTitle`,
            async function (title) {
                return title;
            }
        );
    }

    function setSelectedMenuIndex() {
        return createAsyncThunk(
            `${name}/setSelectedMenuIndex`,
            async function (selectedMenuIndex) {
                return selectedMenuIndex;
            }
        );
    }

    function setCurrentPageIndex() {
        return createAsyncThunk(
            `${name}/setCurrentPageIndex`,
            async function (currentPageIndex) {
                return currentPageIndex;
            }
        );
    }

    // function getPreviousURL() {
    //     return "";
    // }

    function getPreviousURL() {
        return createAsyncThunk(
            `${name}/getPreviousURL`,
            async function (args, { getState }) {
                try {
                    const currentURLList = getState().breadcrumbs.url_list;
                    let prevURL = currentURLList[0];

                    if(currentURLList && currentURLList.length>2) {
                        prevURL = currentURLList[currentURLList.length - 2];
                    }
                    return prevURL;
                } catch (error) {
                    return {
                        url: "/home",
                        state: {}
                    };
                }
            }
        );
    }

}


function createExtraReducers() {
    return (builder) => {
        setCurrentURL();
        setCurrentTitle();
        setSelectedMenuIndex();
        setCurrentPageIndex();
        getPreviousURL();

        function  setCurrentURL () {
            var { pending, fulfilled, rejected } = extraActions.setCurrentURL;
            builder
                .addCase(pending, (state) => {
//                    state.url_list = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    //alert('action.payload: '+JSON.stringify(action.payload));
                    if(action.payload.url && action.payload.url !== "/navigate") {

                        if(!state.reverse_navigation_mode) {
                            var url_list_length = state.url_list.length;
                            if (state.url_list.length === 0 || (state.url_list[url_list_length - 1].url !== action.payload.url)) {
                                state.total_reloads = 1;
                                state.url_list.push({
                                    url: action.payload.url,
                                    state: action.payload.state
                                });
                                if (url_list_length >= 5) {
                                    state.url_list.shift();
                                }
                            } else if (state.url_list.length > 0 && (state.url_list[url_list_length - 1].url === action.payload.url)) {
                                state.total_reloads++;
                                state.url_list[url_list_length - 1] = {
                                    url: action.payload.url,
                                    state: action.payload.state
                                };
                            }

                            // state.previous_url = {
                            //     url: state.url_list[state.url_list.length - 2]?.url,
                            //     state: state.url_list[state.url_list.length - 2]?.state
                            // };
                            state.highest_page_index++;
                            state.current_page_index = state.highest_page_index;
                            // console.log('Forward mode URL List: '+ JSON.stringify(state.url_list));
                        } else {
                            // console.log('Reverse mode URL List (Before removing last 2 entries): '+ JSON.stringify(state.url_list));
                            // state.url_list.pop();
                            // state.url_list.pop();
                            // console.log('Reverse mode URL List (After removing last 2 entries): '+ JSON.stringify(state.url_list));
                        }

                    } else {
                        state.reverse_navigation_mode = false;
                    }
//                    console.log('state.url_list: '+JSON.stringify(state.url_list));
                })
                .addCase(rejected, (state, action) => {
                    //                  state.url_list = { error: action.error };
                });
        }

        function setCurrentTitle() {
            var { pending, fulfilled, rejected } = extraActions.setCurrentTitle;
            builder
                .addCase(pending, (state) => {
//                    state.current_title = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.current_title = action.payload;
                })
                .addCase(rejected, (state, action) => {
//                    state.current_title = { error: action.error };
                });
        }

        function setSelectedMenuIndex() {
            var { pending, fulfilled, rejected } = extraActions.setSelectedMenuIndex;
            builder
                .addCase(pending, (state) => {
//                  state.selected_menu_index = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.selected_menu_index = action.payload;
                })
                .addCase(rejected, (state, action) => {
//                    state.selected_menu_index = { error: action.error };
                });
        }

        function setCurrentPageIndex() {
            var { pending, fulfilled, rejected } = extraActions.setCurrentPageIndex;
            builder
                .addCase(pending, (state) => {
//                  state.selected_menu_index = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.current_page_index = action.payload;
                })
                .addCase(rejected, (state, action) => {
//                    state.selected_menu_index = { error: action.error };
                });

        }

        function getPreviousURL() {
            var { pending, fulfilled, rejected } = extraActions.getPreviousURL;
            builder
                .addCase(pending, (state) => {
//                  state.selected_menu_index = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    // state.previous_url = {
                    //     url: state.url_list[state.url_list.length - 2]?.url,
                    //     state: state.url_list[state.url_list.length - 2]?.state
                    // };
                    //
                    // if(state.url_list.length>=2) {
                    //     state.previous_url = state.url_list[state.url_list.length - 2];
                    // } else {
                    //     state.previous_url = state.url_list[0];
                    // }
                    state.previous_url = action.payload;
                    state.url_list.pop();
                    state.reverse_navigation_mode = true;
                })
                .addCase(rejected, (state, action) => {
//                    state.selected_menu_index = { error: action.error };
                });

        }

    };

}